<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM | User Activity Logs</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="View user activity logs and audit trail" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">User Activity Logs - {{ userFullName }}</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="/dashboard">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="/users">All users</a></li>
                    <li class="breadcrumb-item">
                      <a :href="`/user-details/${userId}`">{{ userFullName }}</a>
                    </li>
                    <li class="breadcrumb-item active">User logs</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Total Activities</p>
                      <h4 class="mb-2">{{ totalLogs }}</h4>
                      <p class="text-muted mb-0">
                          <span class="text-success fw-bold font-size-12 me-2">
                            <i class="ri-arrow-right-up-line me-1 align-middle"></i>+12%
                          </span>
                        from last month
                      </p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-primary rounded-3">
                          <i class="mdi mdi-history font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Woreda Created</p>
                      <h4 class="mb-2">{{ woredaCount }}</h4>
                      <p class="text-muted mb-0">Administrative units</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-success rounded-3">
                          <i class="mdi mdi-map-marker font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Payment Records</p>
                      <h4 class="mb-2">{{ paymentCount }}</h4>
                      <p class="text-muted mb-0">Premium payments</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-warning rounded-3">
                          <i class="mdi mdi-cash font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-truncate font-size-14 mb-2">Member Registrations</p>
                      <h4 class="mb-2">{{ memberCount }}</h4>
                      <p class="text-muted mb-0">New CBHI members</p>
                    </div>
                    <div class="avatar-sm">
                        <span class="avatar-title bg-light text-info rounded-3">
                          <i class="mdi mdi-account-plus font-size-24"></i>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filters -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-2">
                      <label class="form-label">Start Date</label>
                      <input v-model="startDate" type="date" class="form-control" @change="fetchActivityLogs">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">End Date</label>
                      <input v-model="endDate" type="date" class="form-control" @change="fetchActivityLogs">
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Action Type</label>
                      <select v-model="filterAction" @change="applyFilters" class="form-select">
                        <option value="">All Actions</option>
                        <option value="login">Login</option>
                        <option value="create_woreda">Create Woreda</option>
                        <option value="payment_record">Payment Record</option>
                        <option value="payment_view">Payment View</option>
                        <option value="register_member">Register Member</option>
                        <option value="remove_beneficiary">Remove Beneficiary</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Module</label>
                      <select v-model="filterModule" @change="applyFilters" class="form-select">
                        <option value="">All Modules</option>
                        <option value="general">General</option>
                        <option value="payments">Payments</option>
                        <option value="members">Members</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <label class="form-label">Search</label>
                      <input
                          v-model="searchQuery"
                          @input="applyFilters"
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                      >
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                      <button @click="refreshLogs" class="btn btn-primary me-2">
                        <i class="mdi mdi-refresh"></i> Refresh
                      </button>
                      <div class="dropdown">
                        <button class="btn btn-success dropdown-toggle" type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="mdi mdi-download"></i> Export
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="exportDropdown">
                          <li><a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportData">Export Current Page</a></li>
                          <li><a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportAllData">Export All Data</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Activity table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="mb-0">Activity History</h4>
                    <div class="badge bg-info">{{ filteredLogs.length }} Activities</div>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Loading -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading activity logs...</p>
                  </div>

                  <!-- Error -->
                  <div v-else-if="error" class="alert alert-danger" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{ errorMessage }}
                    <button @click="fetchActivityLogs" class="btn btn-sm btn-danger float-end">Retry</button>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-nowrap table-hover dt-responsive">
                      <thead class="table-light">
                      <tr>
                        <th scope="col" @click="sortBy('created_at')" style="cursor:pointer;width:15%">
                          Date &amp; Time <i class="mdi mdi-sort"></i>
                        </th>
                        <th scope="col" @click="sortBy('first_name')" style="cursor:pointer;width:15%">
                          Name <i class="mdi mdi-sort"></i>
                        </th>
                        <th scope="col" @click="sortBy('action')" style="cursor:pointer;width:12%">
                          Action Type <i class="mdi mdi-sort"></i>
                        </th>
                        <th scope="col" @click="sortBy('module')" style="cursor:pointer;width:10%">
                          Module <i class="mdi mdi-sort"></i>
                        </th>
                        <th scope="col" style="width:30%">Details</th>
                        <th scope="col" style="width:10%">IP Address</th>
                        <th scope="col" style="width:8%">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="paginatedLogs.length === 0">
                        <td colspan="7" class="text-center py-4">
                          <p class="mb-0 text-muted">No activity logs found for the selected criteria</p>
                        </td>
                      </tr>

                      <tr v-for="log in paginatedLogs" :key="log.log_id">
                        <td>
                          <span class="fw-semibold">{{ formatDateTime(log.created_at) }}</span>
                        </td>

                        <!-- NAME CELL -->
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                  <span class="avatar-title rounded-circle bg-primary text-white font-size-12">
                                    {{ getUserInitials(log) }}
                                  </span>
                            </div>
                            <div>
                              <div class="fw-semibold">{{ getUserDisplayName(log) }}</div>
                              <small class="text-muted" v-if="log.username">@{{ log.username }}</small>
                            </div>
                          </div>
                        </td>

                        <td>
                              <span :class="getActionBadgeClass(log.action)" class="badge">
                                {{ formatActionType(log.action) }}
                              </span>
                        </td>
                        <td>
                          <span class="text-capitalize">{{ log.module }}</span>
                        </td>
                        <td>
                          <div class="text-wrap" style="max-width: 350px;">
                            <div class="d-flex align-items-start">
                              <i :class="getActionIcon(log.action)" class="me-2 font-size-16 mt-1"></i>
                              <span class="text-muted">{{ truncateText(log.new_values, 100) }}</span>
                            </div>
                          </div>
                        </td>
                        <td><small class="text-muted">{{ log.ip_address || 'N/A' }}</small></td>
                        <td>
                          <button @click="viewDetails(log)" class="btn btn-sm btn-soft-primary" title="View Details">
                            <i class="mdi mdi-eye"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination -->
                    <div v-if="totalPages > 1" class="row mt-4">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ startIndex + 1 }} to {{ endIndex }} of {{ filteredLogs.length }} entries
                          <span v-if="searchQuery || filterAction || filterModule" class="text-muted">
                              (filtered from {{ activityLogs.length }} total entries)
                            </span>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                              <a @click="previousPage" href="javascript: void(0);" class="page-link">Previous</a>
                            </li>
                            <li
                                v-for="page in displayPages"
                                :key="page"
                                class="paginate_button page-item"
                                :class="{ active: page === currentPage }"
                            >
                              <a @click="goToPage(page)" href="javascript: void(0);" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                              <a @click="nextPage" href="javascript: void(0);" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /table -->
                </div>
              </div>
            </div>
          </div>

          <!-- Details Modal -->
          <div v-if="selectedLog" class="modal fade show" style="display:block;background:rgba(0,0,0,0.5);" @click.self="selectedLog = null">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Activity Log Details - ID: {{ selectedLog.log_id }}</h5>
                  <button @click="selectedLog = null" type="button" class="btn-close"></button>
                </div>
                <div class="modal-body">
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">LOG ID</label>
                      <p class="mb-2">{{ selectedLog.log_id }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">TIMESTAMP</label>
                      <p class="mb-2">{{ formatDateTime(selectedLog.created_at) }}</p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">USER</label>
                      <div class="d-flex align-items-center">
                        <div class="avatar-sm me-2">
                            <span class="avatar-title rounded-circle bg-primary text-white">
                              {{ getUserInitials(selectedLog) }}
                            </span>
                        </div>
                        <div>
                          <p class="mb-0 fw-semibold">{{ getUserDisplayName(selectedLog) }}</p>
                          <small class="text-muted">@{{ selectedLog.username }} (ID: {{ selectedLog.user_id }})</small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">MODULE</label>
                      <p class="mb-2"><span class="badge badge-soft-secondary">{{ selectedLog.module }}</span></p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">ACTION</label>
                      <p class="mb-2">
                          <span :class="getActionBadgeClass(selectedLog.action)" class="badge">
                            {{ formatActionType(selectedLog.action) }}
                          </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">RECORD ID</label>
                      <p class="mb-2">{{ selectedLog.record_id || 'N/A' }}</p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12">
                      <label class="fw-bold text-muted small">DESCRIPTION</label>
                      <div class="bg-light p-3 rounded">
                        <p class="mb-0">{{ selectedLog.new_values }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">IP ADDRESS</label>
                      <p class="mb-2">{{ selectedLog.ip_address }}</p>
                    </div>
                    <div class="col-md-6">
                      <label class="fw-bold text-muted small">OLD VALUES</label>
                      <p class="mb-2">{{ selectedLog.old_values || 'N/A' }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <label class="fw-bold text-muted small">USER AGENT</label>
                      <p class="text-break small bg-light p-2 rounded">{{ selectedLog.user_agent }}</p>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="selectedLog = null" type="button" class="btn btn-secondary">Close</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "UserActivityLogs",
  components: { NavigationBar },

  data() {
    return {
      // Loading states
      loading: false,
      error: false,
      errorMessage: '',

      // User info
      userId: null,
      userFullName: 'User',
      userDetails: null,

      // Logs
      activityLogs: [],
      totalLogs: 0,

      // Filters & pagination
      filterAction: '',
      filterModule: '',
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 10,
      sortField: 'log_id',
      sortOrder: 'desc',

      // Dates
      startDate: '',
      endDate: '',

      // UI
      selectedLog: null,
      filteredLogs: []
    };
  },

  computed: {
    woredaCount() {
      return this.activityLogs.filter(log => log.action === 'create_woreda').length;
    },
    paymentCount() {
      return this.activityLogs.filter(log => log.action === 'payment_record').length;
    },
    memberCount() {
      return this.activityLogs.filter(log => log.action === 'register_member').length;
    },
    paginatedLogs() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredLogs.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredLogs.length / this.itemsPerPage) || 1;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(this.startIndex + this.itemsPerPage, this.filteredLogs.length);
    },
    displayPages() {
      const pages = [];
      const maxPages = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
      let end = Math.min(this.totalPages, start + maxPages - 1);
      if (end - start < maxPages - 1) start = Math.max(1, end - maxPages + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },

  created() {
    // Get userId from route params, query, or session
    this.userId =
        this.$route.params.userId ||
        this.$route.query.userId ||
        sessionStorage.getItem('userId') ||
        null;
  },

  mounted() {
    this.initializeComponent();
  },

  methods: {
    async initializeComponent() {
      // Default last 30 days
      const today = new Date();
      const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
      this.endDate = today.toISOString().split('T')[0];
      this.startDate = thirtyDaysAgo.toISOString().split('T')[0];

      // If no userId, use current user's ID & name from session
      if (!this.userId) {
        this.userId = sessionStorage.getItem('userId');
        const fn = sessionStorage.getItem('firstName') || '';
        const ln = sessionStorage.getItem('lastName') || '';
        this.userFullName = `${fn} ${ln}`.trim() || 'Current User';
      }

      // Fetch user details if viewing another user's logs
      if (this.userId && this.userId !== sessionStorage.getItem('userId')) {
        await this.fetchUserDetails();
      }

      await this.fetchActivityLogs();
    },

    async fetchUserDetails() {
      const data = { function: "getUserDetails", userId: this.userId };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.userDetails = response.data.data.user;
          const first = this.userDetails.first_name || this.userDetails.firstName || '';
          const last  = this.userDetails.last_name  || this.userDetails.lastName  || '';
          this.userFullName = `${first} ${last}`.trim() || (this.userDetails.username || 'User');
        }
      } catch (e) {
        console.error('Error fetching user details:', e);
        this.userFullName = 'User';
      }
    },

    async fetchActivityLogs() {
      this.loading = true;
      this.error = false;

      const data = {
        function: "getActivityLogs",
        userId: this.userId,
        startDate: this.startDate,
        endDate: this.endDate,
        limit: 1000,
        offset: 0
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.activityLogs = response.data.data.logs || [];
          this.totalLogs = parseInt(response.data.data.total) || 0;
          this.applyFilters();
        } else {
          this.error = true;
          this.errorMessage = response.data.message || 'Failed to load activity logs';
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = e.message || 'An error occurred while loading activity logs';
        console.error('Error fetching activity logs:', e);
      } finally {
        this.loading = false;
      }
    },

    applyFilters() {
      let filtered = [...this.activityLogs];

      if (this.filterAction) filtered = filtered.filter(l => l.action === this.filterAction);
      if (this.filterModule) filtered = filtered.filter(l => l.module === this.filterModule);

      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        filtered = filtered.filter(l =>
            (l.new_values && l.new_values.toLowerCase().includes(q)) ||
            (l.action && l.action.toLowerCase().includes(q)) ||
            (l.module && l.module.toLowerCase().includes(q)) ||
            (l.ip_address && ('' + l.ip_address).includes(q)) ||
            (l.username && l.username.toLowerCase().includes(q)) ||
            ((l.first_name || l.firstName || '').toLowerCase().includes(q)) ||
            ((l.last_name || l.lastName || '').toLowerCase().includes(q))
        );
      }

      // Sorting
      filtered.sort((a, b) => {
        let aVal = a[this.sortField];
        let bVal = b[this.sortField];

        // When sorting by first_name ensure we use fallbacks
        if (this.sortField === 'first_name') {
          aVal = a.first_name || a.firstName || '';
          bVal = b.first_name || b.firstName || '';
        }

        if (this.sortField === 'log_id') {
          aVal = parseInt(aVal);
          bVal = parseInt(bVal);
        }

        if (this.sortOrder === 'asc') return aVal > bVal ? 1 : -1;
        return aVal < bVal ? 1 : -1;
      });

      this.filteredLogs = filtered;
      this.currentPage = 1;
    },

    resetFilters() {
      this.filterAction = '';
      this.filterModule = '';
      this.searchQuery = '';
      this.applyFilters();
    },

    refreshLogs() {
      this.fetchActivityLogs();
    },

    sortBy(field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortOrder = 'asc';
      }
      this.applyFilters();
    },

    viewDetails(log) {
      this.selectedLog = log;
    },

    formatDateTime(dateStr) {
      if (!dateStr) return 'N/A';
      const date = new Date(dateStr);
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
      return date.toLocaleDateString('en-US', options);
    },

    formatActionType(action) {
      const map = {
        'login': 'Login',
        'logout': 'Logout',
        'create': 'Create',
        'update': 'Update',
        'delete': 'Delete',
        'view': 'View',
        'export': 'Export',
        'import': 'Import',
        'approve': 'Approve',
        'reject': 'Reject',
        'create_woreda': 'Create Woreda',
        'register_member': 'Register Member',
        'update_member': 'Update Member',
        'submit_claim': 'Submit Claim',
        'process_claim': 'Process Claim',
        'payment_record': 'Record Payment',
        'payment_view': 'View Payment',
        'generate_report': 'Generate Report',
        'remove_beneficiary': 'Remove Beneficiary'
      };
      return map[action] || action;
    },

    getActionBadgeClass(action) {
      const map = {
        'login': 'badge-soft-success',
        'logout': 'badge-soft-secondary',
        'create': 'badge-soft-primary',
        'create_woreda': 'badge-soft-primary',
        'update': 'badge-soft-info',
        'delete': 'badge-soft-danger',
        'view': 'badge-soft-secondary',
        'export': 'badge-soft-warning',
        'approve': 'badge-soft-success',
        'reject': 'badge-soft-danger',
        'register_member': 'badge-soft-warning',
        'payment_record': 'badge-soft-success',
        'payment_view': 'badge-soft-info',
        'remove_beneficiary': 'badge-soft-danger'
      };
      return map[action] || 'badge-soft-secondary';
    },

    getActionIcon(action) {
      const map = {
        'login': 'mdi mdi-login text-success',
        'logout': 'mdi mdi-logout text-secondary',
        'create': 'mdi mdi-plus-circle text-primary',
        'create_woreda': 'mdi mdi-map-marker-plus text-primary',
        'update': 'mdi mdi-pencil text-info',
        'delete': 'mdi mdi-delete text-danger',
        'view': 'mdi mdi-eye text-secondary',
        'export': 'mdi mdi-download text-warning',
        'approve': 'mdi mdi-check-circle text-success',
        'reject': 'mdi mdi-close-circle text-danger',
        'register_member': 'mdi mdi-account-plus text-warning',
        'payment_record': 'mdi mdi-cash-check text-success',
        'payment_view': 'mdi mdi-eye text-info',
        'remove_beneficiary': 'mdi mdi-account-remove text-danger'
      };
      return map[action] || 'mdi mdi-circle';
    },

    truncateText(text, length) {
      if (!text) return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + '...';
    },

    // === NAME HELPERS (robust to snake_case / camelCase) ===
    getUserDisplayName(log) {
      const first = log.first_name || log.firstName || '';
      const last  = log.last_name  || log.lastName  || '';
      const full  = `${first} ${last}`.trim();
      return full || log.username || 'Unknown User';
    },

    getUserInitials(log) {
      const first = log.first_name || log.firstName || '';
      const last  = log.last_name  || log.lastName  || '';
      if (first && last) return (first[0] + last[0]).toUpperCase();
      if (first) return first.slice(0, 2).toUpperCase();
      if (log.username) return log.username.slice(0, 2).toUpperCase();
      return 'NA';
    },

    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    goToPage(page) {
      this.currentPage = page;
    },

    exportData() {
      const csv = [
        ['Log ID', 'Date/Time', 'Username', 'Full Name', 'Action', 'Module', 'Details', 'IP Address'],
        ...this.paginatedLogs.map(log => [
          log.log_id,
          this.formatDateTime(log.created_at),
          log.username,
          this.getUserDisplayName(log),
          this.formatActionType(log.action),
          log.module,
          log.new_values,
          log.ip_address
        ])
      ];

      const csvContent = csv.map(row => row.map(cell => `"${cell || ''}"`).join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = `activity_logs_page_${this.currentPage}_${new Date().toISOString().split('T')[0]}.csv`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    },

    exportAllData() {
      const csv = [
        ['Log ID', 'Date/Time', 'Username', 'Full Name', 'Action', 'Module', 'Details', 'IP Address'],
        ...this.filteredLogs.map(log => [
          log.log_id,
          this.formatDateTime(log.created_at),
          log.username,
          this.getUserDisplayName(log),
          this.formatActionType(log.action),
          log.module,
          log.new_values,
          log.ip_address
        ])
      ];

      const csvContent = csv.map(row => row.map(cell => `"${cell || ''}"`).join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = `activity_logs_all_${new Date().toISOString().split('T')[0]}.csv`;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    }
  }
};
</script>

<style scoped>
.badge-soft-primary { color:#556ee6; background-color:rgba(85,110,230,.18); }
.badge-soft-success { color:#34c38f; background-color:rgba(52,195,143,.18); }
.badge-soft-info    { color:#50a5f1; background-color:rgba(80,165,241,.18); }
.badge-soft-warning { color:#f1b44c; background-color:rgba(241,180,76,.18); }
.badge-soft-danger  { color:#f46a6a; background-color:rgba(244,106,106,.18); }
.badge-soft-secondary { color:#74788d; background-color:rgba(116,120,141,.18); }

.page-item.disabled .page-link { cursor:not-allowed; opacity:.6; }
.page-item.active .page-link { background-color:#556ee6; border-color:#556ee6; }

.modal.show { display:block !important; }
.text-wrap { word-wrap:break-word; white-space:normal; }

.btn-soft-primary { color:#556ee6; background-color:rgba(85,110,230,.18); border-color:transparent; }
.btn-soft-primary:hover { color:#fff; background-color:#556ee6; }

.avatar-xs { height:2rem; width:2rem; }
.avatar-sm { height:3rem; width:3rem; }
.avatar-title { align-items:center; display:flex; height:100%; justify-content:center; width:100%; }
</style>
